const whatsApp = {
  title: 'WhatsApp',
  subtitle: 'Sie haben Fragen zu einem Medikament oder möglichen Nebenwirkungen?',
  paragraph1: 'Nicht jede Beratung erfordert einen Besuch vor Ort. Stellen Sie einfach Ihre Fragen. Ihre Apotheke antwortet sicher und diskret (innerhalb der Öffnungszeiten).',
  paragraphMobile: 'Kontaktieren Sie uns bei Fragen direkt über WhatsApp.',
  paragraphDesktop: 'Kontaktieren Sie uns direkt über WhatsApp indem Sie den QR-Code scannen oder auf dem WhatsApp-Button klicken, um den Chat im Browser zu öffnen.',
  cartProcess: {
    title: 'Sie werden weitergeleitet zu IhreApotheken.de - dem digitalen Zuhause Ihrer Vor-Ort-Apotheke.',
    subtitle: 'Bitte haben Sie elnen Augenblick Geduld',
    missingParameters: 'Die URL enthält nicht die erforderlichen Parameter – Pharmacy-ID und Produkte.',
    singleUnavailableProduct: 'Das Produkt {pzn} ist leider nicht mehr verfügbar. Bei Bedarf fragen Sie Ihre Apotheke nach einer Alternative.',
    multipleUnavailableProducts: 'Die Produkte {pzns} sind leider nicht mehr verfügbar. Bei Bedarf fragen Sie Ihre Apotheke nach einer Alternative.',
  },
}

export default whatsApp
